import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
// import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import DownloadIcon from '@mui/icons-material/Download';
import TextField from '@mui/material/TextField';

function Contact() {
  // --- FORM LOGIC (Temporarily Commented Out) ---
  /*
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const form = useRef();

  const sendEmail = (e: any) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    // if (name !== '' && email !== '' && message !== '') {
    //   var templateParams = {
    //     name: name,
    //     email: email,
    //     message: message
    //   };

    //   console.log(templateParams);
    //   emailjs.send('service_id', 'template_id', templateParams, 'api_key').then(
    //     (response) => {
    //       console.log('SUCCESS!', response.status, response.text);
    //     },
    //     (error) => {
    //       console.log('FAILED...', error);
    //     },
    //   );
    //   setName('');
    //   setEmail('');
    //   setMessage('');
    // }
  };
  */
  // ----------------------------------------------

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>
            Interested in my research, control systems work, or collaboration opportunities? 
            <br/>
            I am currently looking for full-time roles where I can bridge the gap between simulation and reality through system modeling, controls development, HIL/SIL validation, and automated testing.
          </p>

          {/* ACTION BUTTONS */}
          <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              gap: '20px', 
              marginTop: '40px',
              flexWrap: 'wrap' 
            }}>
            
            {/* EMAIL BUTTON (Updated to match Resume Button) */}
            <Button 
                variant="contained" 
                size="large"
                endIcon={<SendIcon />}
                href="mailto:mathury@purdue.edu" 
                sx={{
                    // 1. EXACT COLOR MATCH
                    backgroundColor: '#5000ca', 
                    
                    // 2. FORCE WHITE TEXT
                    color: '#ffffff !important', 
                    
                    // 3. EXACT STYLING MATCH
                    fontWeight: 'bold',
                    padding: '12px 30px',
                    borderRadius: '5px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                    textTransform: 'none', 
                    
                    // 4. ANIMATION & HOVER
                    transition: 'transform 0.2s', 
                    '&:hover': {
                        backgroundColor: '#5000ca', 
                        transform: 'scale(1.05)',   // The "Pop" effect
                        boxShadow: '0 6px 8px rgba(0,0,0,0.4)', 
                    }
                }}
            >
                Send Me an Email
            </Button>

            {/* RESUME BUTTON */}
            <Button 
                variant="contained" 
                size="large"
                endIcon={<DownloadIcon />}
                href={process.env.PUBLIC_URL + '/resume.pdf'} 
                target="_blank"
                rel="noreferrer"
                sx={{
                    backgroundColor: '#5000ca', 
                    color: '#ffffff !important', 
                    fontWeight: 'bold',
                    padding: '12px 30px',
                    borderRadius: '5px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                    textTransform: 'none', 
                    transition: 'transform 0.2s', 
                    '&:hover': {
                        backgroundColor: '#5000ca', 
                        transform: 'scale(1.05)', 
                        boxShadow: '0 6px 8px rgba(0,0,0,0.4)', 
                    }
                }}
            >
                Download Resume
            </Button>

          </div>

          {/* OLD FORM (Temporarily Commented Out) */}
          {/*
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
          >
           ... (Form Code) ...
          </Box>
          */}

        </div>
      </div>
    </div>
  );
}

export default Contact;